// eslint-disable-next-line import/no-cycle
import { StoryblokComponent } from '@storyblok/react';

import Footer from '@/components/layouts/Footer';
import { GalleryOverlay } from '@/components/layouts/GalleryGrid';
import Header from '@/components/layouts/Header';
import Hero from '@/components/layouts/Hero';

const Event = ({ story, blok, settingsHeader, settingsFooter }) => (
  <>
    <Hero story={story} blok={blok} type="events">
      <Header theme={'light'} settingsHeader={settingsHeader} />
    </Hero>
    <main role="main" id="main">
      {blok.body
        ? blok.body.map((blk) => (
            <StoryblokComponent blok={blk} key={blk._uid} />
          ))
        : null}
    </main>
    <Footer settingsFooter={settingsFooter} />
    <GalleryOverlay bloks={blok.body} />
  </>
);

export default Event;
